import {
  Box,
  Card,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPenToSquare } from "@fortawesome/free-solid-svg-icons";
import { TaxesAndDiscountsEditor } from "../../../components";
import { useElectronic } from "../../../context/ElectronicContext";
import { useModal } from "../../../context";
import useCoinDetails from "../../../hooks/useCoinDetails";
import { ECurrencyCode } from "../../../Enums/Coin";

function ExportationProductDataDisplayer() {
  const { lineDetail, setLineDetail } = useElectronic();
  const { currentSymbolCoin, currentCoinCode, convertToCurrency } =
    useCoinDetails();
  const { setModalOpen } = useModal();

  const getTotalDiscounts = lineDetailProductDiscountsPercentage =>
    lineDetailProductDiscountsPercentage?.reduce(
      (total, discount) => total + Number(discount || 0),
      0,
    );

  const getProductDiscountedAmount = ({ discountPercentages, totalPrice }) => {
    const totalDiscountPercentage = getTotalDiscounts(discountPercentages);
    const totalDiscountedAmount = totalPrice * (totalDiscountPercentage / 100);
    return totalDiscountedAmount;
  };

  const handleTaxesAndDiscountsUpdate = ({
    lineDetailProductId,
    newTariff,
    newTax,
    updatedDiscountsList,
  }) => {
    setLineDetail(prev =>
      prev.map(lineDetailProduct =>
        lineDetailProduct.id === lineDetailProductId
          ? {
              ...lineDetailProduct,
              tax: newTax,
              Tariff: newTariff,
              discount: updatedDiscountsList,
            }
          : lineDetailProduct,
      ),
    );
  };

  return (
    <Card color="primary" sx={{ padding: "18px 10px" }}>
      <Typography
        fontSize={20}
        fontWeight={600}
        marginBottom="28px"
        variant="h2"
      >
        Detalles de productos
      </Typography>
      <Box
        sx={{
          paddingX: "5px",
          paddingY: "10px",
          display: "flex",
          gap: "30px",
          maxWidth: "100%",
          overflowX: "auto",
        }}
      >
        {lineDetail.map(product => (
          <Card
            color="primary"
            sx={{
              padding: "31px 16px 15px 16px",
              minWidth: "340px",
              maxWidth: "400px",
              border: "1px solid #396E9C",
              boxShadow: "none",
              fontSize: "14px",
            }}
          >
            <Grid container columnSpacing="12px" rowSpacing="12px">
              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Código:
                </Typography>
                <Typography fontSize={14}>
                  {product.product_Code || "---"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Tipo impuesto:
                </Typography>

                <Tooltip arrow title={product.tax?.Description_Tax || "---"}>
                  <Typography noWrap fontSize={14}>
                    {product.tax?.Description_Tax || "---"}
                  </Typography>
                </Tooltip>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Detalle del producto:
                </Typography>
                <Tooltip arrow title={product.description || "---"}>
                  <Typography noWrap fontSize={14}>
                    {product.description || "---"}
                  </Typography>
                </Tooltip>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Porcentaje:
                </Typography>
                <Typography fontSize={14}>
                  {product.Tariff?.Percent
                    ? `${product.Tariff.Percent}%`
                    : "---"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Cantidad:
                </Typography>
                <Typography fontSize={14}>
                  {product.quantity || "---"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Descuento:
                </Typography>
                <Typography fontSize={14}>
                  {currentSymbolCoin}
                  {convertToCurrency({
                    amount: getProductDiscountedAmount({
                      discountPercentages: product.discount,
                      totalPrice: product.total,
                    }),
                    decilmalsNumber: 2,
                    fromCurrencyCode: ECurrencyCode.DOLLAR,
                    toCurrencyCode: currentCoinCode,
                  })}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Unidad:
                </Typography>
                <Typography fontSize={14}>
                  {product.unit_Measure?.Name_UnitOfMeasurement || "---"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Total:
                </Typography>
                <Typography fontSize={14}>
                  {currentSymbolCoin}
                  {convertToCurrency({
                    amount: product.total,
                    decilmalsNumber: 2,
                    fromCurrencyCode: ECurrencyCode.DOLLAR,
                    toCurrencyCode: currentCoinCode,
                  }) || "---"}
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Typography fontSize={14} fontWeight={600}>
                  Precio unitario:
                </Typography>
                <Typography fontSize={14}>
                  {product.unit_price || "---"}
                </Typography>
              </Grid>

              <Grid item xs={6}>
                <Typography fontSize={14} fontWeight={600}>
                  Monto:
                </Typography>
                <Typography fontSize={14}>
                  {convertToCurrency({
                    amount: product.total,
                    decilmalsNumber: 2,
                    fromCurrencyCode: ECurrencyCode.DOLLAR,
                    toCurrencyCode: currentCoinCode,
                  }) || "---"}
                </Typography>
              </Grid>

              <Grid
                item
                alignItems="end"
                display="flex"
                justifyContent="end"
                xs={6}
              >
                <IconButton
                  color="default"
                  size="small"
                  sx={{
                    "backgroundColor": "transparent",
                    "&:hover": {
                      backgroundColor: "rgba(0, 0, 0, 0.04)",
                    },
                  }}
                  onClick={() =>
                    setModalOpen(
                      true,
                      <TaxesAndDiscountsEditor
                        defaultValues={{
                          selectedTariffId: product.Tariff.id,
                          selectedTaxId: product.tax.id,
                          totalPrice: product.total,
                          percentageDiscountsList: product.discount,
                        }}
                        onCancel={() => setModalOpen(false)}
                        onSubmit={({
                          selectedTariff,
                          selectedTax,
                          discountsList,
                          ...others
                        }) => {
                          handleTaxesAndDiscountsUpdate({
                            lineDetailProductId: product.id,
                            newTariff: selectedTariff,
                            newTax: selectedTax,
                            updatedDiscountsList: discountsList,
                          });
                          setModalOpen(false);
                        }}
                      />,
                    )
                  }
                >
                  <FontAwesomeIcon icon={faPenToSquare} />
                </IconButton>
              </Grid>
            </Grid>
          </Card>
        ))}
      </Box>
    </Card>
  );
}

export default ExportationProductDataDisplayer;
